import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";

function RequireAuthWithRole({ role }) {
  const { auth } = useAuth();
  const location = useLocation();

  const email = auth?.email ?? null;
  const roles = auth?.roles ?? [];
  if (!email || !roles.includes(role)) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return <Outlet />;
}

export default RequireAuthWithRole;
